import { render, staticRenderFns } from "./LearningGroupTableByCourseId.vue?vue&type=template&id=b04c5c56&"
import script from "./LearningGroupTableByCourseId.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupTableByCourseId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports